/* eslint-disable @typescript-eslint/camelcase */
export const defaultScheme = (
    isTemplate: boolean,
    isXTMEnabled: boolean,
    isQuestionSet: boolean,
    isItemReviewEnabled: boolean,
    isIBTemplate: boolean,
    isStructureEditorOnQuestion: boolean,
    settings = { isPreviewSet: true, isAuthorEditSet: true }
) => {
    const { isPreviewSet, isAuthorEditSet } = settings;
    return {
        schemeId: 'internal_test_question_scheme',
        name: {
            no_no: 'Inspera beta workspace spørsmål skjema',
            en_us: 'Inspera beta workspace question scheme',
        },
        workspaceGroups: [
            {
                type: 'system_role_testauthor_rel',
                workspaces: [
                    {
                        internal_ref: isStructureEditorOnQuestion ? 'author_question_edit_only_with_editor' : 'author_question_edit_only',
                        visible: isAuthorEditSet,
                    },
                    {
                        internal_ref: 'author_preview',
                        visible: isPreviewSet,
                    },
                ],
            },
            {
                type: 'system_role_testextendedcontentadmin_rel',
                workspaces: [
                    {
                        internal_ref: 'item_bank_default_question',
                        visible: !isTemplate && isItemReviewEnabled && !isIBTemplate,
                    },
                    {
                        internal_ref: 'item_review_xtm',
                        visible: isXTMEnabled && !isTemplate && !isQuestionSet && !isIBTemplate,
                    },
                ],
            },
        ],
    };
};
